module.exports = __webpack_public_path__ + "img/c04_unitimmortal_Normal_ua.80b3228d.webp";